import { render, staticRenderFns } from "./PerformanceIndicatorCard.vue?vue&type=template&id=10dfc311&"
import script from "./PerformanceIndicatorCard.vue?vue&type=script&lang=js&"
export * from "./PerformanceIndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceIndicatorCard.vue?vue&type=style&index=0&id=10dfc311&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports